export const additional_property_types = [
  {
    label: 'Loma-asunto',
    value: 3,
  },
  {
    label: 'Liiketila',
    value: 5,
  },
  {
    label: 'Autotalli',
    value: 6,
  },
  {
    label: 'Varasto',
    value: 7,
  },
  {
    label: 'Paritalo',
    value: 8,
  },
  {
    label: 'Erillistalo',
    value: 9,
  },
  {
    label: 'Lomahuoneisto',
    value: 10,
  },
  {
    label: 'Loma-asunto ulkomailla',
    value: 11,
  },
  {
    label: 'Lomaosake',
    value: 12,
  },
  {
    label: 'Omakotitalotontti',
    value: 13,
  },
  {
    label: 'Vapaa-ajan tontti',
    value: 14,
  },
  {
    label: 'Rivitalotontti',
    value: 15,
  },
  {
    label: 'Autopaikka',
    value: 16,
  },
  {
    label: 'Maatila',
    value: 17,
  },
  {
    label: 'Metsätila',
    value: 18,
  },
  {
    label: 'Toimistotila',
    value: 19,
  },
  {
    label: 'Tuotantotila',
    value: 20,
  },
  {
    label: 'Puutalo-osake',
    value: 21,
  },
  {
    label: 'Luhtitalo',
    value: 22,
  },
  {
    label: 'Muu toimitila',
    value: 23,
  },
  {
    label: 'Muu',
    value: 24,
  },
];

export const requirements = [
  {
    label: 'Parveke',
    value: 'balcony',
  },
  {
    label: 'Hissi',
    value: 'elevator',
  },
  {
    label: 'Oma sauna',
    value: 'privateSauna',
  },
  {
    label: 'Oma tontti',
    value: 'privateLot',
  },
  {
    label: 'Oma ranta',
    value: 'privateBeach',
  },
];

export const property_types = [
  {
    label: 'Kerrostalo',
    value: 2,
  },
  {
    label: 'Rivitalo',
    value: 1,
  },
  {
    label: 'Omakotitalo',
    value: 0,
  },
  {
    label: 'Tontti',
    value: 4,
  },
  {
    label: 'Muu',
    value: 'other',
  },
];

export const target_types = [
  {
    label: 'Myyntikohde',
    value: 'sales',
  },
  {
    label: 'Vuokrakohde',
    value: 'rental',
  },
];
